import { getApi } from "../helpers/api";

async function store(endpoint: string, data: any) {
  return getApi().post(`/${endpoint}`, data);
}

export default store;
